module.exports = __webpack_public_path__ + "img/ecommerce-header.7cdeae31.jpg";